import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const moveUpInitial = keyframes`
  to {
    transform: translate(0, -105%);
  }
`;

const moveUpEnd = keyframes`from {
        transform: translate(0, 100%);
    }
    to {
        transform: translate(0, 0);
    }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 200px;
  flex-direction: column;
`;

const StyledButton = styled.button`
  width: 90px;
  height: 50px;
  border: none;
  background-color: transparent;
  margin: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
`;

const ButtonC = styled(StyledButton)`
  font-size: 15px;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: inset 0 0 0 3px #218921;

  span {
    position: relative;
    z-index: 2;
  }

  &::after {
    position: absolute;
    content: '';
    width: 250px;
    height: 250px;
    background-color: rgba(255, 255, 255, 0.9);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1) rotate(45deg);
    transform-origin: 50%;
    transition: transform 0.5s cubic-bezier(0.61, 0.07, 0.23, 0.89);
    z-index: 1;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(0) rotate(45deg);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
  &:hover {
    text-decoration: underline;
  }
  &:visited {
    color: black;
  }
`;

const EleAnimatedButtonIndustry = () => {
  return (
    <>
      {/* <ButtonA>Click me</ButtonA> */}
      <ButtonC>
        {/* <span>Submit</span> */}
        <StyledLink to="/">
          <span>Branże</span>
        </StyledLink>
      </ButtonC>
    </>
  );
};

export default EleAnimatedButtonIndustry;
